import { axios, Response } from '../index'

const checkConfiguration = (settingId: string): Response<null> => {
  return axios.put(`/v1/settings/${settingId}/check`)
}

export default checkConfiguration
